export const REDUCER_KEY_PATENT_FAMILY_CLUSTERING = 'PatentFamilyClustering';

export const PAGE_LIMIT = 10;

export const RESET_PATENT_FAMILY_CLUSTERING_STATE = 'PatentFamilyClustering/RESET_PATENT_FAMILY_CLUSTERING_STATE';
export const INIT_PATENT_FAMILY_GROUPS = 'PatentFamilyClustering/INIT_PATENT_FAMILY_GROUPS';
export const EXPAND_PATENT_FAMILY_GROUP = 'PatentFamilyClustering/EXPAND_PATENT_FAMILY_GROUP';
export const SET_PAGE_NUMBER = 'PatentFamilyClustering/SET_PAGE_NUMBER';
export const LOAD_PATENT_FAMILY_MEMBERS_START = 'PatentFamilyClustering/LOAD_PATENT_FAMILY_MEMBERS_START';
export const LOAD_PATENT_FAMILY_MEMBERS_SUCCESS = 'PatentFamilyClustering/LOAD_PATENT_FAMILY_MEMBERS_SUCCESS';
